var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLkFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.27mm",
    height: "41.27mm",
    viewBox: "0 0 116.99 116.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #005c8e;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.74,31.99v-13.56h-23.94v-6.84H23.94v6.84H0v86.97h107.74l9.04-56.13c1.19-7.39-2.77-14.28-9.04-17.28ZM4.89,23.31h23.94v-6.84h50.09v6.84h23.94v7.23c-.7-.1-1.42-.15-2.15-.15H12.08l-7.2,44.68V23.31ZM111.95,48.49l-4.22,26.17-4.17,25.86H5.73l10.52-65.24h84.45c.73,0,1.45.07,2.15.21,1.77.34,3.45,1.09,4.89,2.23.6.46,1.16.98,1.64,1.56,2.17,2.56,3.11,5.91,2.57,9.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkFolder);
export default __webpack_public_path__ + "static/media/LK_Folder.84b5bfc53dc971954dbee37620030e3c.svg";
export { ForwardRef as ReactComponent };